import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Profile } from 'src/app/interfaces';
import { ProfileService } from 'src/app/services/profile.service';

@Component({
  selector: 'vl-profile',
  standalone: true,
  imports: [],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {

  public profile: Profile = <Profile>{};

  form = this.formBuilder.group({
    firstName: "",
    lastName: "",
  });

  constructor(
    private profileService: ProfileService,
     private formBuilder: FormBuilder
  ) {
    this.profileService.getProfile$().subscribe((profile) => {
      this.profile = profile
    })
  }

}
